// ─────────────────────────────────────────────────────────────────────────────
// ListToolbar — the row above the table: search, the status filter popover, and
// Add Node. Mirrors MapToolbar (readout on the left, actions on the right) so
// the two views feel like the same page.
// ─────────────────────────────────────────────────────────────────────────────
import { useState, useRef, useEffect } from "react";
import styles from "./ListToolbar.module.css";
import { Icons } from "../../../../components/Icons";
import { STATUS_CONFIG } from "../badges";
import AddNodeButton from "../AddNodeButton";

const FILTER_STATUSES = ["All", "Optimal", "Warning", "Critical", "Offline"];

export default function ListToolbar({
  search, onSearch, filterStatus, onFilter, onAddNode, canWrite = false,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  // close the popover on outside click
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const active = filterStatus !== "All";

  return (
    <div className={styles.toolbar}>
      <div className={styles.searchBox}>
        <span className={styles.searchIcon}>{Icons.search}</span>
        <input
          className={styles.searchInput}
          placeholder="Search nodes..."
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <div className={styles.filterWrap} ref={wrapRef}>
        <button
          className={`${styles.filterBtn} ${active ? styles.filterBtnActive : ""}`}
          onClick={() => setOpen((o) => !o)}
          title="Filter by status"
        >
          {Icons.filter}
          {active && <span className={styles.filterPip} />}
        </button>

        {open && (
          <div className={styles.popover}>
            <div className={styles.popoverLabel}>Status</div>
            {FILTER_STATUSES.map((st) => {
              const cfg = STATUS_CONFIG[st];
              const on = filterStatus === st;
              return (
                <button
                  key={st}
                  className={`${styles.option} ${on ? styles.optionOn : ""}`}
                  onClick={() => { onFilter(st); setOpen(false); }}
                >
                  <span
                    className={styles.optionDot}
                    style={{ background: cfg ? cfg.color : "var(--text-muted)" }}
                  />
                  {st}
                  {on && <span className={styles.check}>✓</span>}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* Creating a node needs read_write on node_monitoring — hidden, not
          disabled, for a viewer who could never use it. */}
      {canWrite && <AddNodeButton onClick={onAddNode} />}
    </div>
  );
}
